export enum ETypeFavori
{
    Item = 1,
    Emplacement = 2,
    PreCommande = 3,
    ApprobationPreCommande = 4,
    Commande = 5,
    Requisition = 6,
    Fournisseur = 7,
    BonCommande = 8,
    Soumission = 9
}